import { ApiPriceRange } from 'common/types'
import { PriceRange } from 'common/types'

export const PriceRangeModel = (priceRange: ApiPriceRange): PriceRange => {
  const { currencyCode, defaultIndicator, end = '', start = '' } = priceRange

  return { currencyCode, defaultIndicator, end, start }
}
